import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../containers/layout'
import SEO from '../components/seo/seo'
import BlockContent from '../components/shared/blockContent'
import ContactPageContent from '../components/contact/contactPageContent'

export default function ContactPage({ data, location }) {
  const headerColor =
    data.page.config && data.page.config.headerColor ? data.page.config.headerColor : 'normal'

  const seo = {
    title: data.page.seo && data.page.seo.title ? data.page.seo.title : data.page.title,
    description: data.page.seo && data.page.seo.description ? data.page.seo.description : null,
    ogImage: data.page.seo && data.page.seo.ogImage ? data.page.seo.ogImage : null,
  }

  return (
    <Layout
      siteConfig={data.siteConfig}
      headerColor={headerColor}
      navItems={data.navigation.items}
      hideFooter={true}
      pageBgColor="black"
      disableStickyNav={true}
    >
      <SEO data={seo} location={location} />
      <BlockContent input={data.page.body}></BlockContent>
      <ContactPageContent siteConfig={data.siteConfig}></ContactPageContent>
    </Layout>
  )
}

export const query = graphql`
  {
    siteConfig: sanitySiteConfig {
      email
      recruitmentEmail
      telephone
      offices: _rawOffices
      social {
        _key
        _type
        name
        url
      }
    }
    page: sanityPage(slug: { current: { eq: "/contact" } }) {
      title
      slug: _rawSlug
      body: _rawBody(resolveReferences: { maxDepth: 10 })
      config: _rawConfig
      seo: _rawSeo(resolveReferences: { maxDepth: 20 })
    }
    navigation: sanityNavigation {
      items {
        title
        slug: _rawSlug(resolveReferences: { maxDepth: 10 })
        config {
          navigationTitle
        }
      }
    }
  }
`
